import React from "react";
import { cutShort } from "../../../../utils/stringUtil";
import Box from "../../../../common/box/Box";

function ReviewItem({ state, label, href, fileName = "", attached = false }) {
  return (
    <Box statusIndicatorPosition={"left"} statusIndicatorColor={attached ? "green" : "grey"}>
      <div className="level ">
        <div className="level-left level-item is-flex-shrink-1">{label}</div>
        <div className="level-right">
          {attached && (
            <Box
              defaultPadding={false}
              isBorderless={true}
              isShadowless={true}
              className={"p-2 has-background-white-ter is-size-7 has-text-weight-bold"}
            >
              <a
                className="is-link has-text-grey-dark"
                rel="noopener noreferrer"
                href={href}
                target="_blank"
              >
                {cutShort(fileName, 45, "...")}
              </a>
            </Box>
          )}
        </div>
      </div>
    </Box>
  );
}

export default ReviewItem;
